import './styles.css';
import { useContext } from 'react';
import { AppContext } from '../../state/ContextProvider';
import { Card } from 'antd';
import DealPortalPng from '../../assets/accounts_page/DealPortal.png';
import AppHeader from '../../components/AppHeader';
import { useSetPageTitle } from '../../utils/hooks';
const { Meta } = Card;

const AccountsPage = () => {
  useSetPageTitle('Accounts');
  const { state } = useContext(AppContext);
  const accounts = state.accounts;

  return (
    <div className={'account-page-container'}>
      <AppHeader />
      <header>
        <h1>Accounts</h1>
      </header>
      <main>
        {accounts?.map((account, index) => (
          <Card
            hoverable
            key={index}
            className={'account-card'}
            cover={<img alt="example" src={DealPortalPng} />}
            onClick={() => {
              window.open(
                `${account.url}/redirect?tokenId=${account.jwtId}`,
                '_self'
              );
            }}
          >
            <Meta title={account.organization} description={account.url} />
          </Card>
        ))}
      </main>
    </div>
  );
};

export default AccountsPage;
